import { SpaceBetween, spacing, styled } from '@lessonup/ui-components';
import React from 'react';

export interface OpenQuestionAnswerWrapperProps {
  showScrollbar?: boolean;
  children: React.ReactNode;
}

export const OpenQuestionAnswerWrapper: React.FC<OpenQuestionAnswerWrapperProps> = ({
  showScrollbar = false,
  children,
}) => {
  return (
    <StyledAnswerAreaPinContent
      direction="x"
      spacing={spacing.size8}
      padding={spacing.size16}
      justifyContent="space-between"
      style={{
        overflowY: showScrollbar ? 'auto' : 'hidden',
      }}
    >
      {children}
    </StyledAnswerAreaPinContent>
  );
};

const StyledAnswerAreaPinContent = styled(SpaceBetween)`
  width: 100%;
  height: 100%;
  scrollbar-gutter: stable;
  position: relative;
`;
